import { j as s } from "../../../node_modules/react/jsx-runtime.js";
const a = ({ data: t }) => /* @__PURE__ */ s.jsx("div", { className: "stamp-wrap", children: /* @__PURE__ */ s.jsx("div", { className: "stamp", dangerouslySetInnerHTML: { __html: t } }) }), m = a;
export {
  m as default
};
